import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubFormComponent } from '../../sub-form/sub-form.component';
@Component({
  selector: 'app-hazard-with-label',
  template: `
      <div class="hazard-description radio-buttons hazard-details" [formGroup]="group" *ngIf="field.style.visibility">
        <p class="dynamic-paragraph"><input [ngClass]="{'pointer-events' : !field.style.editability}" (change)="onChangeLable($event.target)" value="{{hazardName ? hazardName : ''}}" placeholder="Enter Inspection Question" class="form-control hazarawith-label"></p>
        <mat-radio-group class="example-radio-group" [ngClass]="{'pointer-events' : !field.style.editability}" *ngFor="let item of field.data | keys;let i = index">
        <mat-radio-button class="example-radio-button" (change)="onChange(item,i)" [checked]="selected() === item.key" [value]="item.key">
          {{item.value}}
        </mat-radio-button>
      </mat-radio-group>
      <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
        <button *ngIf="isHazardFound()" class="view-details" (click)="viewDetails()">View/edit hazard details <img src="assets/rff-images/hazard-redirect.svg"></button>
      </div>
`,
  styles: []
})
export class HazardWithLabelComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  selectValues;
  hazardName;
  constructor(
    private _validationService: ValidationService,
    private modalService: NgbModal,
  ) { }
  onChange(selectedItem, index) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    this.selectValues = selectedOption;
    if (selectedItem.value === 'Hazards Found') {
      const templateId = this.field.data[index]['formTemplateId'];
      if (templateId) {
        this.hazardFound(templateId);
      }
    } else {
      this.field.value = {
        label: (this.hazardName) ? this.hazardName : 'Inspection Details',
        selectedIndex: index
      }
    }

    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  isHazardFound() {
    if (this.field.value && this.field.value.selectedIndex === 1) {
      return true;
    }
    return false;
  }
  hazardFound(templateId) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-large',
    };
    const modalRef = this.modalService.open(
      SubFormComponent,
      modalOptions
    );

    modalRef.componentInstance.formId = templateId;

    if (this.field.value && this.field.value['data']) {
      modalRef.componentInstance.data = this.field.value['data'];
    }

    modalRef.componentInstance.isEditable = this.field.style.editability;

    modalRef.result.then((data) => {

      this.field.value = {
        label: (this.hazardName) ? this.hazardName : 'Inspection Details',
        selectedIndex: 1,
        data: data.data,
        template: data.template
      }
      this.group.value[this.field.id] = this.field.value;
      const dataCheck = this.group.value;
      this._validationService.applyValidation(this.field, dataCheck, [ValidationType.isRequired, ValidationType.onChange]);
    });
  }
  viewDetails() {
    const templateId = this.field.data[1]['formTemplateId'];
    if (templateId) {
      this.hazardFound(templateId);
    }

  }
  selected() {
    if (this.selectValues) {
      const items = Object.keys(this.selectValues);
      return items[0];
    }
  }
  onChangeLable(event) {
    this.hazardName = event.value;
    if(this.hazardName){
      this.field.value = {
        label : this.hazardName
      }
    }else{
      this.field.value = {
        label : 'Inspection Details'
      }
    }
  }
  ngOnInit() {
    if (this.field.value) {
      this.selectValues = this.field.data[this.field.value.selectedIndex]
      this.hazardName = this.field.value.label;
      (this.hazardName) ? this.hazardName : 'Inspection Details';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/hazard-with-label/hazard-with-label.component.ts